export default {

    init() {
        jQuery( ".itemcollapse" ).click(function() {
            let id = jQuery(this).data('id');

            jQuery('.itemcollapse').not(this).each(function () { 
                jQuery(this).removeClass("active");
                jQuery('button', this).html(`More <i class="fa fa-angle-down"></i>`);
            });

            
            if (jQuery(this).hasClass("active"))
            {
                jQuery(this).removeClass("active");
                jQuery('button', this).html(`More <i class="fa fa-angle-down"></i>`);
                
            } else {
                
                jQuery(this).addClass("active");
                jQuery('button', this).html(`Less <i class="fa fa-angle-up"></i>`);

            }

            
            if (id === undefined)
            {
                return;
            }

            
            let content = jQuery(`.collapsecontent[data-id='${id}']`);

            if (!content)
            {
                return;
            }

            if (content.hasClass("active"))
            {
                content.removeClass("active");
                return;
            }

            jQuery('.collapsecontent').each(function () { 
                jQuery(this).removeClass("active");
            });

            content.addClass("active");

        });
      
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/ambassadors.js